module.exports = __webpack_public_path__ + "static/dapo-f68372874163af3f557a2d8fa073f59a.png";